import { SkeletonBodyText, SkeletonDisplayText } from '@shopify/polaris';
import { Table } from 'antd';
import React from 'react';

const CancelOrderSkeleton = () => {
    const columns = [
        {
            title: 'Shopify Order ID',
            dataIndex: 'shopify_order_id',
            width: '150px',
        },
        {
            title: 'Amazon Order ID',
            dataIndex: 'amazon_order_id',
            width: '150px',
        },
        {
            title: 'Reason',
            dataIndex: 'failure_reason',
            width: '200px',
        },
        {
            title: 'Action',
            dataIndex: 'action',
            width: '100px',
        }
    ];
    const rows = [
        {
            key: '1',
            shopify_order_id: <SkeletonBodyText lines={1} />,
            amazon_order_id: <SkeletonBodyText lines={1} />,
            failure_reason: <SkeletonBodyText lines={2} />,
            action: <SkeletonDisplayText size="medium" />,
        },
        {
            key: '2',
            shopify_order_id: <SkeletonBodyText lines={1} />,
            amazon_order_id: <SkeletonBodyText lines={1} />,
            failure_reason: <SkeletonBodyText lines={2} />,
            action: <SkeletonDisplayText size="medium" />,
        },
        {
            key: '3',
            shopify_order_id: <SkeletonBodyText lines={1} />,
            amazon_order_id: <SkeletonBodyText lines={1} />,
            failure_reason: <SkeletonBodyText lines={2} />,
            action: <SkeletonDisplayText size="medium" />,
        },
        {
            key: '4',
            shopify_order_id: <SkeletonBodyText lines={1} />,
            amazon_order_id: <SkeletonBodyText lines={1} />,
            failure_reason: <SkeletonBodyText lines={2} />,
            action: <SkeletonDisplayText size="medium" />,
        },
        {
            key: '5',
            shopify_order_id: <SkeletonBodyText lines={1} />,
            amazon_order_id: <SkeletonBodyText lines={1} />,
            failure_reason: <SkeletonBodyText lines={2} />,
            action: <SkeletonDisplayText size="medium" />,
        },
        {
            key: '6',
            shopify_order_id: <SkeletonBodyText lines={1} />,
            amazon_order_id: <SkeletonBodyText lines={1} />,
            failure_reason: <SkeletonBodyText lines={2} />,
            action: <SkeletonDisplayText size="medium" />,
        },
        {
            key: '7',
            shopify_order_id: <SkeletonBodyText lines={1} />,
            amazon_order_id: <SkeletonBodyText lines={1} />,
            failure_reason: <SkeletonBodyText lines={2} />,
            action: <SkeletonDisplayText size="medium" />,
        },
        {
            key: '8',
            shopify_order_id: <SkeletonBodyText lines={1} />,
            amazon_order_id: <SkeletonBodyText lines={1} />,
            failure_reason: <SkeletonBodyText lines={2} />,
            action: <SkeletonDisplayText size="medium" />,
        },
        {
            key: '9',
            shopify_order_id: <SkeletonBodyText lines={1} />,
            amazon_order_id: <SkeletonBodyText lines={1} />,
            failure_reason: <SkeletonBodyText lines={2} />,
            action: <SkeletonDisplayText size="medium" />,
        },
        {
            key: '10',
            shopify_order_id: <SkeletonBodyText lines={1} />,
            amazon_order_id: <SkeletonBodyText lines={1} />,
            failure_reason: <SkeletonBodyText lines={2} />,
            action: <SkeletonDisplayText size="medium" />,
        },
        {
            key: '11',
            shopify_order_id: <SkeletonBodyText lines={1} />,
            amazon_order_id: <SkeletonBodyText lines={1} />,
            failure_reason: <SkeletonBodyText lines={2} />,
            action: <SkeletonDisplayText size="medium" />,
        },

    ];
    return <Table
        columns={columns}
        dataSource={rows}
        scroll={{ x: 850, }}
        pagination={false}
        size='middle'
    />;
}

export default CancelOrderSkeleton;